module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-h"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry-2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART ONE")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_vm._v("The Desert")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART TWO")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2"
    }
  }, [_vm._v("The Land")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part3"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART THREE")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part3"
    }
  }, [_vm._v("The Kings and the Prophets")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART FOUR")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Exile")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART FIVE")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herod and Hillel")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART SIX")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus and Christianity")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART SEVEN")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Diaspora")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART EIGHT")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wandering Jew")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART NINE")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into Europe and North")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART TEN")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Discover America")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART ELEVEN")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Holocaust")])])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/bibliographicalnote"
    }
  }, [_vm._v("Bibliographical Note")])])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/images",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Gallery")])])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocentry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Howard Fast")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0